import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {detectInitialLanguage, getLanguageDirection} from './i18n/config';

const initialLanguage = detectInitialLanguage();
document.documentElement.lang = initialLanguage;
document.documentElement.dir = getLanguageDirection(initialLanguage);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // Service worker registration failed — app still works without offline support
    });
  });
}
